import { Component, OnInit, OnDestroy } from '@angular/core';

import {SettingsService} from "../../../core/services/settings/settings.service";


/**
 * This is a placeholder for the welcome part of the home page
 */
@Component({
  selector: 'sb-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit, OnDestroy {
  firstName: string = "";

  constructor(
    public settingsService: SettingsService
  ) { }

  ngOnInit() {
    if (this.settingsService.settings.user && this.settingsService.settings.user.firstName) {
      this.firstName = this.settingsService.settings.user.firstName;
    }
  }

  ngOnDestroy() {
  }
}
